// 退货详情
import React, { Component, Fragment } from 'react'
import { Button, Skeleton } from 'antd'
import { merchantDetail } from '_src/api/api'
import { withRouter } from 'react-router-dom'
import '../../common/style/common.less'
import './style/merchantDetai.less'

@withRouter
class ReturnDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      data: {}      
    }
  }
  componentDidMount () {
    this.loadData()
  }
  loadData () {
    const { search } = this.props.location
    const id = search.split('=')[1]
    merchantDetail(id)
      .then(res=>{
        const { data }= res
        this.setState({
          data,
          loading: false
        })
      })
  }

  lintTo (url) {
    this.props.history.push(url)
  }
  
  render () {
    const { loading } = this.state
    return (
      <Fragment>
        {
          loading
            ?<div className = "skeleton_bar">
              <Skeleton loading = {false} active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>:null
        }
        
        <div className = "ReturnDetail page_content" style = {{height: '90%'}}>
          <div className = "page_top">
            <p className = "page_top_title">商户详情</p>
            <div className = "returnDetail_btn">
              <Button icon = "file-add" style = {{marginRight: 10}} type="primary" onClick = {()=>{ this.lintTo('/system/merchant/add') }}>
                添加商户
              </Button>
              <Button icon = "ordered-list" className = "" type="primary" onClick = {()=>{ this.lintTo('/system/merchant/list') }}>
                查看列表
              </Button>
            </div>
          </div>
          <div className = "page_main" style = {{margin: (0, 'auto'), maxWidth: 1000, marginTop: 20}}>
            {/* <Descriptions>
              <Descriptions.Item label="商户名称">{data.storeName}</Descriptions.Item>
              <Descriptions.Item label="店主姓名">{data.merchantName}</Descriptions.Item>
              <Descriptions.Item label="手机号">{data.mobile}</Descriptions.Item>
              <Descriptions.Item label="商户类型">{data.category&&data.category.name}</Descriptions.Item>
              <Descriptions.Item label="账号">{data.username}</Descriptions.Item>
              <Descriptions.Item label="密码">{data.password}</Descriptions.Item>
              <Descriptions.Item label="商家图片">
                <div className = "merchantImages" style = {{ display: 'flex' }}>
                  <div className = "merchantImages_item" style = {{flex: 1}}>
                    <img src = {data.cover} alt = "" style = {{width: '100%'}} />
                  </div>

                </div>

              </Descriptions.Item>
            </Descriptions> */}
    
          </div>
        </div>
      </Fragment>
    )
  }
}

export default ReturnDetail